'use client';

import PageContainer from '../../../layout/page-container';
import Section from '../../../layout/section';
import { PageHero } from '@/modules/marketing/components/page-shared';
import { Animated, StaggerContainer } from '@/components/ui/animated';

export default function AboutPage() {
  const commitmentCards = [
    { title: 'Transparency', text: 'Clear pricing, verified preceptor profiles, and honest communication throughout the entire process.', color: 'blue' },
    { title: 'Quality', text: 'Every preceptor is carefully vetted to ensure you receive the best clinical education experience.', color: 'blue' },
    { title: 'Support', text: 'Our dedicated team is available to assist you with any questions or concerns throughout your rotation.', color: 'blue' },
    { title: 'Flexibility', text: 'Multiple specialties, locations, and scheduling options to fit your specific educational requirements.', color: 'blue' },
  ];

  return (
    <PageContainer>
      <Animated animation="fade-up" duration={800}>
        <PageHero
          kicker="Our Mission"
          title="About ACE Rotations"
          subtitle="Our goal is to be the best platform for connecting students with verified preceptors, offering transparent pricing, guaranteed placements, and exceptional customer service throughout your clinical rotation journey."
        />
      </Animated>

      {/* Our Story Section */}
      <Section>
        <div className="max-w-4xl mx-auto">
          <Animated animation="fade-up" delay={100}>
            <h2 className="text-3xl font-bold mb-8">Our Story</h2>
          </Animated>
          <Animated animation="fade-up" delay={200}>
            <div className="prose prose-lg max-w-none">
              <p>
                We have been helping students find preceptors to complete their clinical rotations and reach their educational goals for more than 12 years. American Clinical Experience (ACE) was created in 2014 by Jon Bernad, with the goal in mind of matching students with the best preceptors that will help them complete their rotations successfully.
              </p>
              <p>
                ACE Rotations is a platform focused on simplifying how students locate, evaluate, and book clinical preceptors across multiple specialties. We aim to reduce friction and ensure equitable access to quality rotations.
              </p>
            </div>
          </Animated>
        </div>
      </Section>

      {/* Our Approach Section */}
      <Section>
        <div className="max-w-4xl mx-auto">
          <Animated animation="fade-up" delay={100}>
            <h2 className="text-3xl font-bold mb-8">Our Approach</h2>
          </Animated>
          <Animated animation="fade-up" delay={200}>
            <div className="prose prose-lg max-w-none">
              <p>
                We combine curated data, geographic context, and feedback patterns so students and preceptors can connect with clarity and confidence. There is a whole team ready to work on your application, and help you with any problem or question you may have.
              </p>
            </div>
          </Animated>
        </div>
      </Section>

      {/* Our Commitment Section */}
      <Section>
        <div className="max-w-4xl mx-auto">
          <Animated animation="fade-up" delay={100}>
            <h2 className="text-3xl font-bold mb-8">Our Commitment to You</h2>
          </Animated>
          <StaggerContainer staggerDelay={100} animation="fade-up" className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {commitmentCards.map((card, index) => (
              <div 
                key={card.title}
                className="p-6 border-2 border-blue-100 rounded-xl bg-white hover:shadow-lg hover:border-blue-200 hover:-translate-y-1 transition-all duration-300"
              >
                <h3 className="text-xl font-semibold mb-3 text-blue-600">{card.title}</h3>
                <p className="text-gray-700">{card.text}</p>
              </div>
            ))}
          </StaggerContainer>
        </div>
      </Section>
    </PageContainer>
  );
}
